import {useTranslationStore} from '../../stores/translationStore';
import {mapState} from 'pinia';
import type {TranslationParams, ValidTranslationKey} from '../types/translations';
import {defineComponent} from 'vue';
import {translateWithTranslations} from '../helpers/translationHelper';

export {translateWithTranslations};

/**
 * Searches for a value inside the current translations provided be the pinia store matching `transKey`.
 * This function should only be called inside a Vue context.
 *
 * @param transKey The key for which the translations value should be found
 * @param params Additional parameters that should be replaced inside the found translation.
 * @returns {String}
 */
export function translate(transKey: ValidTranslationKey, params: TranslationParams = []): string {
    const {translations} = useTranslationStore();

    return translateWithTranslations(translations, transKey, params);
}

export default defineComponent({
    computed: {
        ...mapState(useTranslationStore, ['translations']),
    },
    methods: {
        __(transKey: ValidTranslationKey, params: TranslationParams = []) {
            return translateWithTranslations(this.translations, transKey, params);
        },
    },
});
